import {CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import React, { createRef, useEffect, useState } from 'react'

import PlaceDetails from '../PlaceDetails/PlaceDetails'

import useStyles from './styles'

const List = ({places,childClicked,isLoading,type,setType,rating,setRating}) => {
    const [elRefs,setElRefs] = useState([]);
    const classes = useStyles();

    useEffect(()=> {
        setElRefs((refs) => Array(places?.length).fill().map((_,i)=> elRefs[i] || createRef()));

       
    },[places]);

    
    return (
        <div className={classes.container}>
            <Typography variant='h4'>Hotels,Restaurant and Activities close to you</Typography>
            {isLoading ? (
                <div className={classes.loading}>
                    <CircularProgress size='5rem'/>
                </div>
            ) : (
                <>
            <FormControl className={classes.formControl}>
                <InputLabel>Type</InputLabel>
                <Select value={type} onChange={(e)=> setType(e.target.value)}>
                    <MenuItem value='restaurants'>Restaurants</MenuItem>
                    <MenuItem value='hotels'>Hotels</MenuItem>
                    <MenuItem value='attractions'>Activities</MenuItem>
                </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
                <InputLabel id='rating'>Rating</InputLabel>
                <Select id='rating' value={rating} onChange={(e)=> setRating(e.target.value)}>
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="3">Above 3.0</MenuItem>
                    <MenuItem value="4">Above 4.0</MenuItem>
                    <MenuItem value="4.5">Above 4.5</MenuItem>
                </Select>
            </FormControl>
            <Grid container spacing={3} className={classes.list}>
                {places?.map((place,i)=>(
                    <Grid ref={elRefs[i]} item key={i} xs={12}>
                      <PlaceDetails 
                            place={place}
                            selected={Number(childClicked)===i}
                            refProp={elRefs[i]} 
                      />
                    </Grid>
                ))}
            </Grid>
            </>
            )}
        </div>
  );
}

export default List;